import { IconArrowRight, IconClose, IconFrozen, IconSelected } from '@ui/src';
import { CardStatus } from '../../../../hoc/common/cards/types';

const getCardStatusIcon = (status: CardStatus) => {
  let icon;

  switch (status) {
    case CardStatus.ORDERED:
      icon = <IconArrowRight />;
      break;
    case CardStatus.ACTIVE:
      icon = <IconSelected />;
      break;
    case CardStatus.CANCELED:
      icon = <IconClose />;
      break;
    case CardStatus.FROZEN:
      icon = <IconFrozen />;
      break;
    default:
      icon = <div />;
      break;
  }

  return icon;
};

export default getCardStatusIcon;
